module.exports = __webpack_public_path__ + "img/Group_12.aadf3de1.png";